import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/whg-park/api/order/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/whg-park/api/order/get',
    method: 'post',
    data: data
  });
}
export function refundAdmin(data) {
  return request({
    url: '/whg-park/api/activityItem/refundAdmin',
    method: 'post',
    data: data
  });
}
export function activeWriteOff(data) {
  return request({
    url: '/whg-park/api/activityItem/activeWriteOff',
    method: 'post',
    data: data
  });
}
export function activeWriteOffAll(data) {
  return request({
    url: '/whg-park/api/activityItem/activeWriteOffAll',
    method: 'post',
    data: data
  });
}
export function refund(data) {
  return request({
    url: '/wechat/api/wxPay/refund',
    method: 'post',
    data: data
  });
}